import React, { useEffect, useState } from 'react'
import { isPresentInArray, toggleId } from '../../../../HelperFunctions'

let newSelectedItemIds = []
export default function ImpressionSearch(props) {
  const { valueField, textField, hideSearch, defaultValues, onSelectHook, wrapperClasses, heading, autoCompleteLoad } = props
  const [selectedItemIds, setSelectedItemIds] = useState(defaultValues ?? [])
  const [search, setSearch] = useState(null)
  const [filteredData, setFilteredData] = useState([])

  useEffect(() => {
    handleAutoCompleteLoad({})
  }, [])

  const handleChecked = (itemId) => {
    newSelectedItemIds = toggleId(selectedItemIds, itemId)
    setSelectedItemIds(newSelectedItemIds)
    onSelectHook(newSelectedItemIds)
  }

  const handleAutoCompleteLoad = async (filters) => {
    let res = await autoCompleteLoad(filters)
    setFilteredData(res ?? [])
  }

  const handleUserSearch = (val) => {
    setSearch(val)
    handleAutoCompleteLoad({ search: val })
  }

  return (
    <div className={`${wrapperClasses}`}>
      {!hideSearch && <div className="input-group mb-5">
        <input value={search} onChange={(e) => handleUserSearch(e.target.value)} type="text" className="form-control form-control-sm" placeholder={`Type to search`} />
        <div className="input-group-append">
          <span className="input-group-text search-button position-static bg-light py-0"><i className="la la-search text-muted" /></span>
        </div>
      </div>}
      {filteredData.length > 0 ?
        filteredData.map(item => (
          <div className="custom-control custom-checkbox mx-3" onClick={() => handleChecked(eval(`item.${valueField}`))}>
            <input type="checkbox" className="custom-control-input"
              checked={isPresentInArray(selectedItemIds, eval(`item.${valueField}`))}
            />
            <label className="custom-control-label">{eval(`item.${textField}`)}</label>
          </div>
        )) :
        <h6 className="w-100 text-center pb-3 pt-6">No Record found</h6>
      }
    </div>
  )
}